import type { DimensionFixtureExample } from "../../../fixtures/dimensions";
import { InputDimensionExampleProps } from "../../../fixtures/dimensions/input.dimension.fixture";
import { Comparator } from "../../../types/common";
import { DimensionTypes } from "../../../types/dimensions";

import type { ListBuilderDimensionProps } from "./";

export class ListBuilderPropFixtures {
    public static basic: ListBuilderDimensionProps = {
        id: "list-builder",
        configuration: {
            label: "list builder example",
            tooltip: "tooltip",
        },
        dependencies: [],
        type: DimensionTypes.LIST_BUILDER,
    };

    public static regexValidator: ListBuilderDimensionProps = {
        id: "list-builder",
        configuration: {
            label: "list builder example",
            tooltip: "tooltip",
        },
        dependencies: [],
        type: DimensionTypes.LIST_BUILDER,
    };

    public static cdbInputValidator: ListBuilderDimensionProps = {
        id: "list-builder",
        configuration: {
            label: "brands",
            tooltip: "tooltip",
            validator: {
                type: "cdb_inputs" as any,
                inputSource: "tnf_preseason_parameters",
                column: "brand_name",
            },
        },
        dependencies: [],
        type: DimensionTypes.LIST_BUILDER,
    };

    public static cdbInputValidatorWithMinMaxItems: ListBuilderDimensionProps =
        {
            id: "list-builder",
            configuration: {
                label: "brands",
                tooltip: "tooltip",
                validator: {
                    type: "cdb_inputs" as any,
                    inputSource: "tnf_preseason_parameters",
                    column: "brand_name",
                },
                minItems: 5,
                maxItems: 20,
            },
            dependencies: [],
            type: DimensionTypes.LIST_BUILDER,
        };

    public static cdbInputValidatorWithDependency: ListBuilderDimensionProps = {
        id: "list-builder",
        dependencies: [InputDimensionExampleProps.basic.id],
        configuration: {
            label: "brands",
            tooltip: "tooltip",
            validator: {
                type: "cdb_inputs" as any,
                inputSource: "tnf_preseason_parameters",
                column: "brand_name",
                inputParameterFilters: [
                    {
                        dimension: InputDimensionExampleProps.basic.id,
                        condition: Comparator.EQUALS,
                        key: "l2_browse_node_id",
                    },
                ],
            },
        },
        type: DimensionTypes.LIST_BUILDER,
    };
}

export class ListBuilderDimensionExamples {
    public static basicExample: DimensionFixtureExample = {
        id: "list-builder",
        name: "list builder - basic",
        description: "simple list builder",
        dimensions: [[ListBuilderPropFixtures.basic]],
    };

    public static dependencyExample: DimensionFixtureExample = {
        id: "list-builder-dependency",
        name: "list builder - dependecy",
        description: "simple list builder",
        dimensions: [
            [InputDimensionExampleProps.basic, ListBuilderPropFixtures.basic],
        ],
    };

    public static cdbInputValidatorExample: DimensionFixtureExample = {
        id: "list-builder-cdb-input-validator",
        name: "list builder - cdb input validator",
        description: "cdb list builder",
        dimensions: [[ListBuilderPropFixtures.cdbInputValidator]],
    };

    public static cdbInputValidatorWithDependencyExample: DimensionFixtureExample =
        {
            id: "list-builder-cdb-input-validator-dep",
            name: "list builder - cdb input validator with dependency",
            description: "cdb list builder",
            dimensions: [
                [
                    InputDimensionExampleProps.basic,
                    ListBuilderPropFixtures.cdbInputValidatorWithDependency,
                ],
            ],
        };

    public static cdbInputValidatorWithMinMaxExample: DimensionFixtureExample =
        {
            id: "list-builder-cdb-input-validator-min-max",
            name: "list builder - cdb input validator with min max",
            description: "cdb list builder",
            dimensions: [
                [ListBuilderPropFixtures.cdbInputValidatorWithMinMaxItems],
            ],
        };
}
